const APP_MAIN_PAGE_TYPE = 'APP_MAIN_PAGE_TYPE';
export default APP_MAIN_PAGE_TYPE ;
